import React from 'react';
import { Navigate, Route } from 'react-router-dom';

const catchAllRouteElement = <Route path="*" element={<Navigate to="" replace />} />;

export default catchAllRouteElement;
